import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Accordion from "./UI/Accordion"

export default function SideBySide(props) {
  return (
    <div className="py-8 bg-light overflow-hidden lg:py-8">
      <div className="relative max-w-xl px-4 mx-auto sm:px-6 lg:px-8 lg:max-w-7xl">
        <div className="relative mt-8 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div className={`relative ${props.imgRight ? "" : "order-last"}`}>
            <h3 className="text-2xl font-extrabold tracking-tight text-blue sm:text-3xl">
              {props.header}
            </h3>
            {props.subheader && (
              <p className="mt-3 text-lg text-gray-500">{props.subheader}</p>
            )}

            <dl className="mt-10 space-y-10">
              <Accordion items={props.items} />
            </dl>
          </div>

          <div
            className="relative flex justify-center mt-10 -mx-4 lg:mt-0"
            aria-hidden="true"
          >
            <GatsbyImage image={getImage(props.image)} alt="" />
          </div>
        </div>
      </div>
    </div>
  )
}
